export default __webpack_public_path__ + "maps-examples-building-extrusions-1200-d6a31877a0b45be5436f8305dd5f96c6.png";